(function ($) {

    var MESSAGE = {
        get: function (status) {
            var msg;
            switch (status) {
                case 901:
                    return '참여작가 제한을 넘었습니다. 작가는 20명까지 참여할 수 있습니다.';
                default:
                    return '오류가 발생했습니다.';
            }
        }
    };

    var $layer;
    var $container;
    var $userList;
    var $userCount;
    var $msgBox;
    var $moreListSpinner;
    var _magazineNo;
    var _magazineAddress;
    var _userList;
    var _userCount;
    var _moreList;
    var _isLoading;

    var _init = function (magazineNo, magazineAddress) {
        _magazineNo = magazineNo;
        _magazineAddress = magazineAddress;
        _userList = [];
        _userCount = 0;
        _moreList = true;

        $container = $(B.Util.getTemplate('popup-user-list.hbs', {
            title: '참여신청 관리',
            showCount: true,
            count: _userCount
        }));
        $layer.append($container);

        $userList = $container.find('.user_list');
        $userCount = $container.find('.user_count');
        $moreListSpinner = $container.find('.spinner');

        $container.on('click', onClick);
        $layer.on('scroll', onScroll);
        $(window).on('keydown', onKeydown);
    };

    var _show = function (magazineNo, magazineAddress) {
        $layer = B.Util.layer.showLayerBase();

        if (!$container) {
            _init(magazineNo, magazineAddress);
            _reloadList();
        }

        $container.show();
    };

    var _hide = function () {
        B.Util.layer.hideLayerBase();
        $container.hide();
    };

    var _reloadList = function () {
        if (_isLoading || !_moreList) {
            return;
        }

        _isLoading = true;

        var lastCreateTime = 0;

        if (_userList && _userList.length > 0) {
            lastCreateTime = _userList[_userList.length - 1].createTime;
        }

        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/magazine/' + _magazineNo + '/author/requests',
            method: 'GET',
            data: {
                createTime: lastCreateTime
            },
            success: function (data) {
                _setUserCount(data.data.totalCount);
                _appendUserList(data.data.list);
                _setMoreList(data.data.moreList);
                _isLoading = false;
                onScroll();
            },
            error: function (r) {
                _isLoading = false;
                _showMessage(MESSAGE.get(r.status));
            }
        });
    };

    var _setUserCount = function (totalCount) {
        _userCount = totalCount;
        $userCount.text(_userCount);

        if (_userCount == 0) {
            $userList.hide();
            _showMessage('신청한 작가가 없습니다.');
        } else {
            $userList.show();
        }
    };

    var _setMoreList = function (moreList) {
        _moreList = moreList;

        if (_moreList) {
            $moreListSpinner.show();
        } else {
            $moreListSpinner.hide();
        }
    };

    var _appendUserList = function (list) {
        for (var i = 0; i < list.length; i++) {
            _userList.push(list[i]);
            $userList.append(_makeUserView(list[i]));
        }
    };

    var _removeUserView = function (user) {
        $userList.find('li[data-userid=' + user.userId + ']').remove();
    };

    var _makeUserView = function (user) {
        return $(B.Util.getTemplate('popup-magazine-request-item.hbs', user));
    };

    var _findUserByUserId = function (userId, callback) {
        var i;
        for (i = 0; i < _userList.length; i++) {
            if (_userList[i].userId == userId) {
                callback(i, _userList[i]);
                return;
            }
        }
    };

    var _setMoreList = function (moreList) {
        _moreList = moreList;

        if (_moreList) {
            $moreListSpinner.show();
        } else {
            $moreListSpinner.hide();
        }
    };

    var _acceptRequest = function (userId) {
        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/magazine/' + _magazineNo + '/author',
            method: 'POST',
            data: {
                userId: userId
            },
            success: function (r) {
                _findUserByUserId(userId, function (index, user) {
                    console.log(index, user);
                    _userList.splice(index, 1);
                    _setUserCount(_userCount - 1);
                    _removeUserView(user);
                });
            },
            error: function (r) {
                _showMessage(MESSAGE.get(r.status));
            }
        });
    };

    var _denyRequest = function (userId) {
        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/magazine/' + _magazineNo + '/author/deny',
            method: 'POST',
            data: {
                userId: userId
            },
            success: function (data) {
                _findUserByUserId(userId, function (index, user) {
                    console.log(index, user);
                    _userList.splice(index, 1);
                    _setUserCount(_userCount - 1);
                    _removeUserView(user);
                });
            },
            error: function (r) {
                _showMessage(MESSAGE.get(r.status));
            }
        });
    };

    var _showMessage = function (message) {
        if (!$msgBox) {
            $msgBox = $("<div class='message'></div>");
            $container.append($msgBox);
        }

        if (message) {
            $msgBox.html(B.Util.getTemplate('alert.hbs', {
                alertWrapTitle: message
            }));
            $msgBox.show();
            $userList.hide();
            $moreListSpinner.hide();
        } else {
            $msgBox.hide();
        }
    };

    var onClick = function (e) {
        if (!$container.is(':visible')) {
            return;
        }

        var btn = _getActionButton(this, e.target);
        var action = btn.data('action');
        var userId = btn.data('userid');

        if (action != null) {
            e.preventDefault();
        }

        if (action == 'close') {
            _hide();
        } else if (action == 'acceptRequest') {
            _acceptRequest(userId);
        } else if (action == 'denyRequest') {
            _denyRequest(userId);
        }
    };

    var onScroll = function (e) {
        if (!$container.is(':visible')) {
            return;
        }

        _adjustHeader();

        if (!_moreList) {
            return;
        }

        var top = $moreListSpinner.offset().top - $layer.offset().top;
        var appearTop = $layer.height();

        if (appearTop > top) {
            _reloadList();
        }
    };

    var _adjustHeader = function () {
        var top = $layer.scrollTop();
        var fixedClass = 'fixed';

        if (top > 0) {
            $container.addClass(fixedClass);
        } else {
            $container.removeClass(fixedClass);
        }
    };

    var onKeydown = function (e) {
        if (!$container.is(':visible')) {
            return;
        }

        if (e.keyCode == 27) {
            _hide();
            e.preventDefault();
        }
    };

    var _getActionButton = function (container, target) {
        var btn = $(target);
        while (!btn.is(container) && !btn.data('action')) {
            btn = btn.parent();
        }

        return btn;
    };

    B.Magazine.Request = {
        show: function (magazineNo, magazineAddress) {
            _show(magazineNo, magazineAddress);
        },
        hide: function () {
            _hide();
        }
    };

})(jQuery);
